import React from 'react';

import { Box, Button, Typography } from '@material-ui/core';
import { TbCertificate } from 'react-icons/tb';
import { RiGraduationCapLine } from 'react-icons/ri';

import { Mode } from '../types';
import { COPY } from '../config';
import useStyles from '../styles';

interface Props {
  onChoose: (mode: Mode) => void;
}

export const ChoosePhase = ({ onChoose }: Props) => {
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="column" gridGap={16}>
      <Box>
        <Typography variant="h6">{COPY.choose.title}</Typography>
        <Typography variant="body2" color="textSecondary">
          {COPY.choose.subtitle}
        </Typography>
      </Box>

      <Button variant="outlined" className={classes.optionCard} onClick={() => onChoose('cscs')}>
        <Box className={classes.optionIcon}>
          <TbCertificate size="24px" />
        </Box>
        <Typography variant="subtitle1">{COPY.choose.cscs}</Typography>
      </Button>

      <Button
        variant="outlined"
        className={classes.optionCard}
        onClick={() => onChoose('qualification')}
      >
        <Box className={classes.optionIcon}>
          <RiGraduationCapLine size="24px" />
        </Box>
        <Typography variant="subtitle1">{COPY.choose.qualification}</Typography>
      </Button>
    </Box>
  );
};
